<template>
  <div class="footer">
    <div class="wrap">
      <p>版权所有 © 2025 www.z-srm.com |
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33021202001647">浙公网安备 33021202001647号</a> |
        <a href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018181号-1</a> |
        浙江小蚁信息科技有限公司 Zhejiang Xiaoyi Information Technology Co.,Ltd
      </p>
      <!-- <div class="left">
        <ul>
          <li><img src="../assets/img/logo2.png" alt="" /></li>
          <li>
            <h4>众力供应链</h4>
            <p>数字化供应链平台</p>
          </li>
        </ul>
        <p>
          Powered by浙江小蚁信息科技有限公司 
          <a href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018181号-2</a> |
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33021202001647">浙公网安备 33021202001647号</a></p>
      </div>
      <div class="right">
        <p><span @click="routerJump(1)">众力供应链平台</span><span @click="routerJump(2)">资讯中心</span></p>
        <p>Zhejiang Xiaoyi Information Technology Co., Ltd</p>
        <p>浙江小蚁信息科技有限公司</p>
        <p>Tel: 13761855854</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import router from '@/router';

export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {
    routerJump(index) {
      if (index === 1) {
        window.open('https://www.z-scm.com/#/login', '_blank')
      } else if (index === 2) {
        this.$router.push('/infoCenter')
      }
    },
    handleClickGuide(e, hash) {
      // 暂时不让点击
      // return false
      let guideHash = e.target.innerText
      if (hash) {
        guideHash = hash
      }
      this.$router.push({
        path: `guide#${guideHash}`,
      })
    },
  },
  created() {},
  mounted() {},
}
</script>
<style scoped lang="less">
.footer {
  height: 68px;
  background-color: rgba(245, 246, 247, 1);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  .wrap {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      width: 100%;
      color: rgba(0, 0, 0, 0.40);
      font-weight: bold;
      font-size: 14px;
      text-align: center;
      a {
        color: rgba(0, 0, 0, 0.40);
      }
    }
  }
}
</style>
